import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('market', ['market']),
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-research/sushi-market-research.js